import React, { FC } from 'react';
import i18n from 'i18n-js';
import UnavailableContent, { UnavailableContentProps } from './UnavailableContent';
import { ContentUnavailableCentralPart } from './ContentUnavailableCentralPart';
import { font as initialFont } from '@styles/fonts';

interface OperatorPanelConnectorLoadingProps extends Omit<UnavailableContentProps, 'children'> {}

const OperatorPanelConnectorLoading: FC<OperatorPanelConnectorLoadingProps> = ({ CC, machineName, isOperator, machineStatus, insetBottom,insetTop, scale, font = initialFont, }) => {
  return (
    <UnavailableContent {...{ CC, machineName, machineStatus, isOperator, insetBottom,insetTop, scale, font }}>
      <ContentUnavailableCentralPart
        {...{
          CC,
          title: `${i18n.t('Connecting')}...`,
          titleAlreadyTranslated: true,
          titleFont: 'Roboto Extra Large Title',
          titleColor: 'Label/Light/Always Light Tertiary',
          scale,
          font,
        }}
      />
    </UnavailableContent>
  );
};

export default OperatorPanelConnectorLoading;
